export const SUMMARY_BLOCK_CATEGORY_KEY = 'fact' as const;
export const SUMMARY_BLOCK_COMPONENT_KEY = 'summaryBlock' as const;
